import { Component } from 'react';
import Isvg from 'react-inlinesvg';
import { API_ENDPOINT } from '../../constants';
import ListBuilder from '../../components/listBuilder';
import Page from '../../containers/page';
import { updateParamsHelper, getParamsFromURL } from '../../helpers/custom.helper';
import { Container, Row, Col, Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import view from '../../assets/svg/eye.svg';
import deleteIcon from '../../assets/svg/garbage.svg';

const STATUS_LABELS = {
    FAILED: 'Failed',
    SUCCESS: 'Success',
    READY_FOR_MANUAL_REVIEW: 'Manual Review',
};

const STATUS_CLASS = {
    FAILED: 'failed',
    SUCCESS: 'success',
    READY_FOR_MANUAL_REVIEW: 'manual-review',
};

class JournalSyncLogs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            total: 0,
            params: {
                entries: 10,
                page: 0,
                sortField: '_id',
                sortType: -1,
                filter: '',
            },
            loading: true,
            initialList: [],
            error: null,
            statusFilter: '',
            errorHistoryModal: null,
        };
    }

    get = async () => {
        this.setState({ loading: true, initialList: [] });

        try {
            const response = await fetch(`${API_ENDPOINT}/journal/sync-queue/get`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${localStorage.getItem('authToken')}`,
                },
                body: JSON.stringify({
                    groupAlias: localStorage.getItem('groupAlias'),
                    total: this.state.total,
                    entries: this.state.params?.entries,
                    page: this.state.params?.page,
                    sortField: this.state.params?.sortField,
                    sortType: this.state.params?.sortType,
                    filter: this.state.params?.filter,
                    statusFilter: this.state.statusFilter,
                }),
            });

            const data = await response.json();

            if (data.items) {
                this.setState({ loading: false, initialList: data.items, total: data.total });
            } else {
                this.setState({ loading: false, error: data.error || null });
            }
        } catch (err) {
            this.setState({ loading: false, error: err?.message || 'Error fetching journal sync queue' });
        }
    };

    delete = async (id) => {
        this.setState({ loading: true });
        try {
            await fetch(`${API_ENDPOINT}/journal/sync-queue/${id}`, {
                method: 'DELETE',
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('authToken')}`,
                },
            });
            await this.get();
        } catch (err) {
            this.setState({ loading: false, error: err?.message || 'Error deleting journal sync queue item' });
        }
    }

    componentDidMount() {
        const urlParams = getParamsFromURL();

        const newParams = {
            ...this.state.params,
            entries: urlParams.entries,
            filter: urlParams.filter,
        };

        this.setState({ params: newParams }, () => {
            if (this.props.initialList) {
                this.setState({ loading: false, initialList: this.props.initialList });
            } else {
                this.get();
            }
        });
    }

    componentDidUpdate(prevProps) {
        if (
            prevProps._groupId !== this.props._groupId ||
            prevProps.view !== this.props.view
        ) {
            this.get();
        }
    }

    updateSort = (field, type) => {
        updateParamsHelper(this, { sortField: field, sortType: type });
    };

    updateParams = (name, value, restart = false) => {
        updateParamsHelper(this, { [name]: value }, restart);
    };

    updateMultipleParams = (fields, restart = false) => {
        updateParamsHelper(this, fields, restart);
    };

    formatTs = (ts) => {
        if (!ts) return '-';
        return new Date(ts).toLocaleString('sv-SE');
    };

    openErrorHistory = (item) => {
        this.setState({ errorHistoryModal: item });
    };

    closeErrorHistory = () => {
        this.setState({ errorHistoryModal: null });
    };


    render() {
        const { params, initialList, loading, total, statusFilter, errorHistoryModal } = this.state;

        return (
            <div className={this.props.autoHideSidebar ? 'dashboard dashboard-auto-hide' : 'dashboard'}>
                <Container fluid>
                    <Row>
                        <Col lg='12'>
                            <div className='panel aeb-panel'>
                                <div className='panel-header'>
                                    <h5 className='component-header'>
                                        {'Journal Sync Queue'.translate(this.props.lang)}
                                    </h5>
                                </div>

                                <select
                                    value={statusFilter}
                                    onChange={(e) => this.setState({ statusFilter: e.target.value }, () => this.get())}
                                    className='patientPrescriptionListLogsSweden-filter'
                                >
                                    <option value=''>{'All'.translate(this.props.lang)}</option>
                                    <option value='FAILED'>{'Failed'.translate(this.props.lang)}</option>
                                    <option value='SUCCESS'>{'Success'.translate(this.props.lang)}</option>
                                    <option value='READY_FOR_MANUAL_REVIEW'>{'Manual Review'.translate(this.props.lang)}</option>
                                </select>

                                <ListBuilder
                                    lang={this.props.lang}
                                    loading={loading}
                                    total={total}
                                    hideEntries={false}
                                    showNumeration={false}
                                    fields={[
                                        { type: 'text', label: 'Collection target'.translate(this.props.lang), name: 'collectionName' },
                                        { type: 'text', label: 'Collection root'.translate(this.props.lang), name: 'collectionItemRootName' },
                                        { type: 'text', label: 'Item ID'.translate(this.props.lang), name: 'collectionItemId' },
                                        { type: 'text', label: 'Root Item ID'.translate(this.props.lang), name: 'collectionItemRootId' },
                                        { type: 'text', label: 'Platform'.translate(this.props.lang), name: 'platform' },
                                        { type: 'text', label: 'Target'.translate(this.props.lang), name: 'target' },
                                        { type: 'text', label: 'Status'.translate(this.props.lang), name: 'statusBadge' },
                                        { type: 'text', label: 'Retries'.translate(this.props.lang), name: 'retries' },
                                        { type: 'text', label: 'Last attempt'.translate(this.props.lang), name: 'lastAttemptFormatted' },
                                        { type: 'text', label: 'Next attempt'.translate(this.props.lang), name: 'nextAttemptFormatted' },
                                        { type: 'text', label: 'Created'.translate(this.props.lang), name: 'createdFormatted' },
                                        // { type: 'text', label: 'Last error'.translate(this.props.lang), name: 'lastError' },
                                    ]}
                                    items={initialList.map((item) => {
                                        return {
                                            ...item,
                                            statusBadge: (
                                                <div className={`patientPrescriptionListLogs-status-${STATUS_CLASS[item.status] || 'failed'}${item.status === 'READY_FOR_MANUAL_REVIEW' ? ' journal-sync-status--manual-review' : ''}`}>
                                                    {STATUS_LABELS[item.status] || item.status}
                                                </div>
                                            ),
                                            retries: `${item.retryCount ?? 0} / ${item.maxRetries ?? 3}`,
                                            lastAttemptFormatted: this.formatTs(item.lastAttemptAt),
                                            nextAttemptFormatted: this.formatTs(item.nextAttemptAt),
                                            createdFormatted: this.formatTs(item.createdAt),
                                            // lastError: (() => {
                                            //     const lastErr = item.errorHistory?.length
                                            //         ? item.errorHistory[item.errorHistory.length - 1]?.error
                                            //         : null;
                                            //     return lastErr
                                            //         ? <span className='journal-sync-error-message' title={lastErr}>{lastErr.length > 60 ? lastErr.slice(0, 60) + '…' : lastErr}</span>
                                            //         : '-';
                                            // })(),
                                        };
                                    })}
                                    actions={[
                                        {
                                            component: <Isvg src={view} className='view-icon' />,
                                            onClick: (item) => {
                                                if (item.errorHistory?.length) {
                                                    this.openErrorHistory(item);
                                                }
                                            },
                                        },
                                        {
                                            component: <Isvg src={deleteIcon} className='delete-icon' />,
                                            onClick: (item) => this.delete(item._id),
                                        },
                                    ]}
                                    rawItems={this.state.initialList}
                                    params={params}
                                    sortField={params.sortField}
                                    sortType={params.sortType}
                                    updateSort={this.updateSort}
                                    updateParams={this.updateParams}
                                    updateMultipleParams={this.updateMultipleParams}
                                />
                            </div>
                        </Col>
                    </Row>
                </Container>

                {errorHistoryModal && (
                    <Modal isOpen centered toggle={this.closeErrorHistory} size='lg'>
                        <ModalHeader toggle={this.closeErrorHistory}>
                            {'Error History'.translate(this.props.lang)}
                        </ModalHeader>
                        <ModalBody className='journal-sync-modal-body'>
                            {errorHistoryModal.errorHistory.length === 0 ? (
                                <p className='journal-sync-modal-empty'>{'No errors recorded.'.translate(this.props.lang)}</p>
                            ) : (
                                errorHistoryModal.errorHistory.map((entry, i) => (
                                    <div key={i} className='journal-sync-modal-entry'>
                                        <div className='journal-sync-modal-entry-header'>
                                            <strong className='journal-sync-modal-entry-num'>#{i + 1}</strong>
                                            <span className='journal-sync-modal-entry-ts'>{this.formatTs(entry.timestamp)}</span>
                                        </div>
                                        {entry.rawRequest && (
                                            <div className='journal-sync-modal-section'>
                                                <strong className='journal-sync-modal-section-title'>{'Raw Request'.translate(this.props.lang)}</strong>
                                                <pre className='journal-sync-modal-pre'>{JSON.stringify(entry.rawRequest, null, 2)}</pre>
                                            </div>
                                        )}
                                        {entry.rawResponse && (
                                            <div className='journal-sync-modal-section'>
                                                <strong className='journal-sync-modal-section-title'>{'Raw Response'.translate(this.props.lang)}</strong>
                                                <pre className='journal-sync-modal-pre'>{JSON.stringify(entry.rawResponse, null, 2)}</pre>
                                            </div>
                                        )}
                                    </div>
                                ))
                            )}
                        </ModalBody>
                        <ModalFooter>
                            <Button color='secondary' onClick={this.closeErrorHistory}>
                                {'Close'.translate(this.props.lang)}
                            </Button>
                        </ModalFooter>
                    </Modal>
                )}
            </div>
        );
    }
}

export default Page(JournalSyncLogs);
